import ChatInterface from "@/components/chat/chat-interface";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/buyer/orders/$orderid/chat")({
	component: RouteComponent
});

function RouteComponent() {
	return <ChatInterface />;
}
